import { Injectable } from '@angular/core';

import { grpcOperator } from '@lyra/app/core/api/grpc/pipe-operators/grpc';
import { Empty, UserApi } from '@mark/web-contracts';
import { from } from 'rxjs';

import { GrpcCommonService } from './common.service';

@Injectable()
export class SubstanceUserGrpcContractService extends GrpcCommonService<UserApi.SubstanceUserWebGrpcContractClient> {
  constructor(protected _GrpcContract: UserApi.SubstanceUserWebGrpcContractClient) {
    super();
  }

  getLastCalculated() {
    return from(this._GrpcContract.GetLastCalculated(new Empty(), this.getMetadata())).pipe(grpcOperator());
  }
}
